// extracted by mini-css-extract-plugin
export default {"contents":"tD-z","sectionHeading":"uD-z"};